// import { EmployerType } from '@/constants';
import { getValue, curry, curryPartner } from './helpers';

// function fnEmployerContributionRate(modifier) {
//   return function EmployerContributionRate() {
//     return getValue(this, `inferred.EmployerType${modifier}`) === EmployerType.GOVERNMENT && getValue(this, `inferred.MemberContributions${modifier}`) > 0;
//   };
// }
// export const EmployerContributionRate = curry(fnEmployerContributionRate);
// export const EmployerContributionRate2 = curryPartner(fnEmployerContributionRate);

function fnOneOffContributionMadeAtAge(modifier) {
  return function OneOffContributionMadeAtAge() {
    const ageNow = getValue(this, `inputs.AgeNow${modifier}`);
    const retirementAge = getValue(this, `inputs.RetirementAge${modifier}`);

    if (ageNow >= retirementAge - 1) {
      return true;
    }
    return false;
  };
}
export const OneOffContributionMadeAtAge = curry(fnOneOffContributionMadeAtAge);
export const OneOffContributionMadeAtAge2 = curryPartner(fnOneOffContributionMadeAtAge);
